export class User {
    id: number;
    phone : number;
    name : string;
    gotra : string;
    nakshatra : number;
    emailid: string;
    password:string;
    user_role:number;
    categories:Categories[];
    //categories:any;
    
    address : string;
    is_life_member : Boolean;
    is_special_member : Boolean;
    is_reset_password:number;
    sevacategory?:any;
    is_active:number;
    veda: string;
}
export class Categories {
    seva_category_id:number;
    description:string;
}



// WEBPACK FOOTER //
// ./src/models/User.ts